import { Fragment } from "react";
import { Link } from "react-router-dom";

import cgch from "../media/img/partners/cgch.jpg";
import interlingva from "../media/img/partners/interlingva.jpg";
import vibor from "../media/img/partners/vibor.jpg";
import juice from "../media/img/partners/Juice-Master.jpg";
import sdek from "../media/img/partners/sdek.jpg";
import balagan from "../media/img/partners/balagan.jpg";
import chicco from "../media/img/partners/Chicco.jpg";
import verba from "../media/img/partners/verba.jpg";
import logForSu from "../media/img/partners/log-for-su.jpg";
import tomTailor from "../media/img/partners/tomTailor.jpg";
import paoloConte from "../media/img/partners/paoloConte.jpg";
import ralf from "../media/img/partners/ralf.jpg";
import nemeckaya from "../media/img/partners/nemeckaya.jpg";
import piccolo from "../media/img/partners/piccolo.jpg";
import coffeeShop from "../media/img/partners/coffeeShop.png";
import originalMarines from "../media/img/partners/originalMarines.jpg";
import leLokl from "../media/img/partners/leLokl.jpg";
import rossipi from "../media/img/partners/rossipi.jpg";
import galleryHome from "../media/img/partners/galleryHome.jpg";
import cinnabon from "../media/img/partners/cinnabon.jpg";
import glch from "../media/img/partners/glch.jpg";
import maximum from "../media/img/partners/maximum.jpg";
import dacha from "../media/img/partners/dacha.jpg";
import love from "../media/img/partners/love.jpg";
import relax from "../media/img/partners/relax.jpg";
import bloknot from "../media/img/partners/bloknot.jpg";
import fashionWeek from "../media/img/partners/fashionWeek.jpg";
import loft from "../media/img/partners/loft.jpg";
import it from "../media/img/partners/it.jpg";
import tous from "../media/img/partners/tous.jpg";
import muzhskoiVkus from "../media/img/partners/muzhskoiVkus.jpg";
import metersbonwe from "../media/img/partners/metersbonwe.jpg";
import trussardiJeans from "../media/img/partners/trussardiJeans.jpg";
import oazis from "../media/img/partners/oazis.jpg";
import marcOPolo from "../media/img/partners/marcOPolo.jpg";
import baleno from "../media/img/partners/baleno.jpg";
import benetton from "../media/img/partners/benetton.jpg";
import calliope from "../media/img/partners/calliope.jpg";
import DKNY from "../media/img/partners/DKNY.png";
import escadaS from "../media/img/partners/escadaS.jpg";
import galleryShoes from "../media/img/partners/galleryShoes.jpg";
import hugoBoss from "../media/img/partners/hugoBoss.png";
import linens from "../media/img/partners/linens.jpg";
import luhta from "../media/img/partners/luhta.jpg";
import newbalance from "../media/img/partners/newbalance.png";
import okaidi from "../media/img/partners/okaidi.png";
import pimkie from "../media/img/partners/pimkie.jpg";
import terranova from "../media/img/partners/terranova.jpg";
import tkUzhPol from "../media/img/partners/tkUzhPol.png";
import tkVoronezh from "../media/img/partners/tkVoronezh.png";
import tonyMoly from "../media/img/partners/tonyMoly.png";
import vazhAcces from "../media/img/partners/vazhAcces.jpg";

import { ReactTitle } from "react-meta-tags";

const HelpMan = () => {
  const items = [
    {
      href: "https://shoppingcenter-gallery-chizhov.ru/",
      image: cgch,
      title: "Центр Галереи Чижова – многофункциональный центр",
      description: "Партнер с 2003 года.",
    },
    {
      href: "https://www.interlingua.edu.ru/",
      image: interlingva,
      title: "Интерлингва – школа иностранных языков.",
      description: "Партнер с 2010 года.",
    },
    {
      href: "https://vyborstroi.ru/",
      image: vibor,
      title: `"Выбор" - строительная компания.`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://www.juicemaster.ru/",
      image: juice,
      title: `Juice-Bar – сеть джус баров.`,
      description: "Партнер с 2014 года.",
    },
    {
      href: "https://www.cdek.ru/",
      image: sdek,
      title: `Сдек – служба курьерской доставки и отправления грузов`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://balagan-city.ru/",
      image: balagan,
      title: `Balagan City – арт-шоу-ресторан`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://glch.ru/shop/Chicco/46",
      image: chicco,
      title: `Chicco - сеть магазинов для детей и их родителей`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://verbav.ru/",
      image: verba,
      title: `Verba - cалон флористики.`,
      description: "Партнер с 2015 года.",
    },
    {
      href: "",
      image: logForSu,
      title: `ФОТОПЛЮС - сеть магазинов цифровой техники.`,
      description: "Партнер с 2015 года.",
    },
    {
      href: "https://glch.ru/shop/TomTailor/53",
      image: tomTailor,
      title: `TOM TAILOR – магазин модной одежды.`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://glch.ru/shop/PaoloConte/17",
      image: paoloConte,
      title: `Paolo Conte - магазин модной обуви и аксессуаров.`,
      description: "Партнер с 2014 года.",
    },
    {
      href: "https://ralf.ru/",
      image: ralf,
      title: `RALF RINGER - магазин женской и мужской обуви.`,
      description: "Партнер с 2015 года.",
    },
    {
      href: "https://nemobuv.ru/",
      image: nemeckaya,
      title: `НЕМЕЦКАЯ ОБУВЬ - обувной магазин.`,
      description: "Партнер с 2015 года.",
    },
    {
      href: "",
      image: piccolo,
      title: `Piccolo – сетевое кафе итальянского мороженого.`,
      description: "Партнер с 2014 года.",
    },
    {
      href: "https://www.coffeeshopcompany.ru/",
      image: coffeeShop,
      title: `CoffeShop - венская кофейня`,
      description: "Партнер с 2015 года.",
    },
    {
      href: "https://glch.ru/shop/OriginalMarines/51",
      image: originalMarines,
      title: `Original Marines – магазин детской одежды популярного итальянского бренда`,
      description: "Партнер с 2016 года.",
    },
    {
      href: "http://leloclewatch.ru/",
      image: leLokl,
      title: `Ле Локль – часовой салон`,
      description: "Партнер с 2013 года.",
    },
    {
      href: "https://vk.com/rossipigallery",
      image: rossipi,
      title: `Золотые россыпи - ювелирный магазин ассоциации Галереи Чижова`,
      description: "Партнер с 2004 года.",
    },
    {
      href: "https://glch.ru/shop/GalleryHome/33",
      image: galleryHome,
      title: `Gallery Home - Маркет товаров для дома и декора Галерея Чижова.`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://cinnabonrussia.com/",
      image: cinnabon,
      title: `CINNABON - это всемирно известный бренд самых вкусных булочек с корицей, представленный в более 60 странах мира.`,
      description: "Партнер с 2013 года.",
    },
    {
      href: "https://infovoronezh.ru/",
      image: glch,
      title: `Газета «Галерея Чижова» - городской еженедельник, который вот уже 8 лет является источником полезной и, главное, интересной информации для своих читателей.`,
      description: "Информационный партнер с 2004 года.",
    },
    {
      href: "",
      image: maximum,
      title: `Радиостанция «Максимум - Воронеж».`,
      description: "Размещение информационных материалов.",
    },
    {
      href: "",
      image: dacha,
      title: `Радиостанция «Дача - Воронеж».`,
      description: "Размещение информационных материалов.",
    },
    {
      href: "",
      image: love,
      title: `Радиостанция «Лав - Воронеж».`,
      description: "Размещение информационных материалов.",
    },
    {
      href: "https://relax-fm.ru/",
      image: relax,
      title: `Радиостанция "Relax FM".`,
      description: "Информационная поддержка. Партнер с 2016 года.",
    },
    {
      href: "https://bloknot-voronezh.ru/",
      image: bloknot,
      title: `Блокнот Воронеж  - информационно-справочный портал.`,
      description: "Информационная поддержка. Партнер с 2013 года.",
    },
    {
      href: "https://glch.ru/shop/FashionWeekOutlet/13",
      image: fashionWeek,
      title: `Fashion Week Outlet – дисконт-центр, в котором представлены известные бренды мира со скидкой до 90%.`,
      description: "Партнер с 2013 года.",
    },
    {
      href: "https://glch.ru/shop/Loft/34",
      image: loft,
      title: `LOFT – магазин одежды знаменитого европейского бренда.`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://glch.ru/shop/IT/1",
      image: it,
      title: `iT – магазин мужской и женской одежды известных мировых брендов.`,
      description: "Партнер с 2012 года.",
    },
    {
      href: "https://www.tous.ru/",
      image: tous,
      title: `TOUS – магазин испанского ювелирного бренда.`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://glch.ru/shop/%D0%9C%D1%83%D0%B6%D1%81%D0%BA%D0%BE%D0%B9%D0%B2%D0%BA%D1%83%D1%81/8",
      image: muzhskoiVkus,
      title: `Мужской вкус – магазин мужской и женской одежды для создания делового стиля.`,
      description: "Партнер с 2014 года.",
    },
    {
      href: "https://glch.ru/shop/Metersbonwe/28",
      image: metersbonwe,
      title: `Metersbonwe - магазин одежды для мужчин, женщин и детей, крупнейшего китайского бренда.`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://glch.ru/shop/TrussardiJeans/23",
      image: trussardiJeans,
      title: `Trussardi Jeans – магазин одежды итальянского бренда.`,
      description: "Партнер с 2017 года.",
    },
    {
      href: "https://glch.ru/shop/%D0%9E%D0%B0%D0%B7%D0%B8%D1%81/22",
      image: oazis,
      title: `Oasis – мультибрендовый магазин женской одежды.`,
      description: "Партнер с 2012 года.",
    },
    {
      href: "https://glch.ru/shop/MarcOPolo/3",
      image: marcOPolo,
      title: `Marc O'Polo – магазин одежды класса Сasual Wear немецкого бренда.`,
      description: "Партнер с 2007 года.",
    },
    {
      href: "https://www.instagram.com/vazhnyy_akses_gallery_chizhov/",
      image: vazhAcces,
      title: `Важный аксессуар – салон сумок.`,
      description: "",
    },
    {
      href: "https://tony-moly.com/",
      image: tonyMoly,
      title: `Tony Moly – бренд корейской косметики.`,
      description: "",
    },
    {
      href: "https://dkny.ru/",
      image: DKNY,
      title: `DKNY – бренд одежды.`,
      description: "",
    },
    {
      href: "https://www.escada.com/",
      image: escadaS,
      title: `Escada Sport – магазин брендовой одежды.`,
      description: "",
    },
    {
      href: "https://www.hugoboss.com/ru/home",
      image: hugoBoss,
      title: `Hugo Boss - компания-производитель модной одежды.`,
      description: "",
    },
    {
      href: "https://www.instagram.com/linens_vrn/",
      image: linens,
      title: `Linens - лидирующий бренд на рынке домашнего текстиля в Турции.`,
      description: "",
    },
    {
      href: "https://www.instagram.com/lescon_gallery_chizhov/",
      image: "",
      title: `Lescon - турецкий бренд одежды и товаров для спорта.`,
      description: "",
    },
    {
      href: "https://www.instagram.com/gallery_shoes_gallery_chizhov/",
      image: galleryShoes,
      title: `Gallery Shoes – проект Центра Галереи Чижова, объединяющий в одном магазине несколько известнейших европейских и американских брендов.`,
      description: "",
    },
    {
      href: "https://www.terranovastyle.ru/",
      image: terranova,
      title: `Terranova - известный итальянский бренд.`,
      description: "",
    },
    {
      href: "https://www.calliope.style/it-it/",
      image: calliope,
      title: `Calliope - популярная итальянская одежда.`,
      description: "",
    },
    {
      href: "https://www.instagram.com/pimkie_gallery_chizhov/",
      image: pimkie,
      title: `Pimkie – французский бренд одежды, обуви и аксессуаров.`,
      description: "",
    },
    {
      href: "http://www.okaidi.com/",
      image: okaidi,
      title: `Okaidi - популярный французский бренд стильной детской и подростковой одежды.`,
      description: "",
    },
    {
      href: "https://ru.benetton.com/",
      image: benetton,
      title: `UNITED COLORS OF BENETTON – итальянская марка молодежной одежды.`,
      description: "",
    },
    {
      href: "https://www.luhta.ru/",
      image: luhta,
      title: `LUHTA Finland Fashion – всемирно известная финская марка одежды для всей семьи.`,
      description: "",
    },
    {
      href: "https://www.instagram.com/baleno_gallery_chizhov/",
      image: baleno,
      title: `Baleno - известный гонконгский бренд демократичной мужской, женской и детской одежды.`,
      description: "",
    },
    {
      href: "https://newbalance.ru/",
      image: newbalance,
      title: `New Balance – бренд обуви.`,
      description: "",
    },
    {
      href: "",
      image: tkUzhPol,
      title: `ТК «Южный полюс».`,
      description: "",
    },
    {
      href: "",
      image: tkVoronezh,
      title: `Торговый комплекс «Воронежский».`,
      description: "",
    },
    {
      href: "",
      image: "",
      title: `Воронежская городская поликлиника № 8.`,
      description: "",
    },
  ];
  return (
    <Fragment>
      <ReactTitle title="Наши друзья и партнеры" />
      <br />
      <ul className="breadcrumb">
        <li>
          <Link to="/">Главная</Link>
        </li>
        <li className="active">Наши друзья и партнеры</li>
      </ul>
      <h1>Наши друзья и партнеры</h1>
      <div className="helpman-wrap">
        <div className="helpman">
          {items.map((item) => {
            return (
              <>
                {item.href ? <a
                  key={item.title}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer">
                  <div className="adv-item">
                    {item.image && <img src={item.image} alt={item.title} />}
                    <h3>{item.title}</h3>
                    <span>{item.description}</span>
                  </div>
                </a> : <div className="adv-item">
                {item.image && <img src={item.image} alt={item.title} />}
                  <h3>{item.title}</h3>
                  <span>{item.description}</span>
                </div>}
              </>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
};

export default HelpMan;
